<template>
  <div id="shopping-cart">
    <van-popup
      v-model="cartShowtval"
      closeable
      round
      position="bottom"
      :style="{ height: '375px' }"
      @close="childMethod()"
    >
      <div class="cart-list">
        <div class="title">药品列表</div>
        <div v-if="cartList.length===0" class="no-list">您还没有添加药品哦~</div>
        <ul class="cart-box">
          <li v-for="(item,index) in cartList" :key="index">
            <div class="cart-left">
              <p>
                <span v-show="parseInt(item.prescriptionYn)===1">Rx</span>
                {{ item.commonName}}
              </p>
            </div>
            <div id="cart-right" class="cart-right">
              <p>
                <van-stepper
                  v-model="item.quantity"
                  min="0"
                  input-width="50"
                  max="999"
                  button-size="30px"
                  @plus="quantityAdd(item)"
                  @minus="quantityMinus(item)"
                  @blur="quantityBlur(item)"
                />
                <span>g</span>
                <van-icon name="delete" size="22" color="#999" @click="deleteCart(item)"/>
              </p>
            </div>
          </li>
        </ul>
        <div class="submitBtn">
          <div @click="childMethod">确定</div>
        </div>
        
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    cartShowt: {
      type: Boolean,
      default: false
    },
    cartList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      cartShowtval: this.cartShowt
    };
  },
  watch: {
    cartShowt(val) {
      this.cartShowtval = val;
    }
  },
  methods: {
    childMethod() {
      this.$emit("closeCart");
    },
    deleteCart(item) {
      this.$emit("deleteListData", item);
      this.$emit("deleteCart", item);
    },
    editCart(index) {
      this.$emit("editCart", index);
    },
    quantityAdd(item) {
      this.$emit("updateListData", item);
    },
    quantityMinus(item) {
      console.log('item.quantity mins', item.quantity)
      if (item.quantity <= 1) {
        this.$emit("deleteListData", item)
        this.$emit("deleteCart", item)
      }
      this.$emit("updateListData", item);
    },
    quantityBlur(item) {
      this.$nextTick(()=>{
        if (item.quantity <= 0) {
          item.show = false
          this.$emit("deleteListData", item)
          this.$emit("deleteCart", item)
        }
        this.$emit("updateListData", item);
      })
      
    }
  }
};
</script>
<style lang="scss" scoped>
#shopping-cart{
  .cart-list{
    padding: 0 15px;
    .title{
      text-align: center;
      font-size: 18px;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #eee;
    }
    .submitBtn{
      width: 100%;
      height: 70px;
      background: #fff;
      position: fixed;
      bottom: 0;
      left: 0;
      >div{
        position: absolute;
        left: 15px;
        width: 345px;
        height: 50px;
        background: #01B956;
        border-radius: 25px;
        line-height: 50px;
        text-align: center;
        color: #fff;
        font-size: 18px;
      }
    }
    .cart-box {
      padding: 0;
      height:250px;
      overflow-y: scroll;
      .cart-left{
          width:58%;
          flex:none;
          p{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
      }
      
      #cart-right /deep/{
        .van-stepper{
          border: 1px solid #efeff5;
          border-radius: 26px;
        }
        p {
          
          display: flex;
          align-items: center;
          span {
            font-size:14px;
            margin-left: 0;
            margin-right: 10px;
            &.edit,
            &.delete {
              top: 5px;
            }
          }
          .van-stepper__minus,
          .van-stepper__plus {
            width: 26px !important;
            height: 26px !important;
            border: none;
            border-radius: 50%;
          }
          .van-stepper__minus {
            background: #fff;
            color: #000;
          }
          .van-stepper__plus {
            background: #fff;
            color: #000;
          }
          .van-stepper__input {
            background: #fff;
            width:40px!important;
          }
        }
      }
    }
  }
  
}
.van-popup /deep/ .van-popup__close-icon {
  top:15px;
}
</style>
